import React, { useState, useEffect, useCallback } from 'react';
import { Table, Badge } from 'react-bootstrap';
import { ButtonComponent } from './elements';
import Swal from 'sweetalert2';
import { obtenerSolicitudesCupoGira, aprobarSolicitudCupo, rechazarSolicitudCupo, getGira } from '../api/giras.ts';

export default function SolicitudesCupoAdminComponent({ giraId }) {
  const [solicitudes, setSolicitudes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtro, setFiltro] = useState('pendiente');
  const [error, setError] = useState(null);
  const [valorExtraGira, setValorExtraGira] = useState(null);

  const cargarSolicitudes = useCallback(async () => {
    if (!giraId) {
      console.error('giraId no válido:', giraId);
      setError('ID de gira inválido');
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      console.log('Cargando solicitudes para gira:', giraId);
      const resultado = await obtenerSolicitudesCupoGira(giraId);
      console.log('Resultado obtenerSolicitudesCupoGira:', resultado);
      if (!resultado.error && resultado.data) {
        console.log('Solicitudes cargadas:', resultado.data);
        setSolicitudes(resultado.data);
      } else if (resultado.data && Array.isArray(resultado.data)) {
        console.log('Datos son array:', resultado.data);
        setSolicitudes(resultado.data);
      } else {
        console.log('Error o sin datos:', resultado);
        setError(resultado.msg || 'No se pudieron cargar las solicitudes');
        setSolicitudes([]);
      }
    } catch (err) {
      console.error('Error al cargar solicitudes:', err);
      setError('Error al cargar solicitudes: ' + err.message);
      setSolicitudes([]);
    }
    setLoading(false);
  }, [giraId]);

  useEffect(() => {
    cargarSolicitudes();
    
    // Cargar valor extra de la gira
    const cargarValorExtra = async () => {
      if (!giraId) return;
      try {
        const resultado = await getGira(giraId);
        if (resultado && resultado.gira && resultado.gira.pro_valorextra) {
          setValorExtraGira(resultado.gira.pro_valorextra);
        } else {
          setValorExtraGira(0);
        }
      } catch (error) {
        console.error('Error al cargar valor extra de la gira:', error);
        setValorExtraGira(0);
      }
    };
    
    cargarValorExtra();
  }, [cargarSolicitudes, giraId]);

  const getEstadoBadge = (estado) => {
    switch (estado) {
      case 'pendiente':
        return <Badge bg="warning" text="dark">Pendiente</Badge>;
      case 'aprobado':
        return <Badge bg="success">Aprobado</Badge>;
      case 'rechazado':
        return <Badge bg="danger">Rechazado</Badge>;
      default:
        return <Badge bg="secondary">{estado}</Badge>;
    }
  };

  const formatearFecha = (fecha) => {
    if (!fecha) return '-';
    return new Date(fecha).toLocaleDateString('es-CL');
  };

  const handleAprobar = async (solicitud) => {
    const { value: formValues } = await Swal.fire({
      title: 'Aprobar Solicitud de Cupo',
      html: `
        <div style="text-align: left;">
          <h6 style="color: #2196F3; margin-bottom: 15px; font-weight: bold;">Alumno: ${solicitud.soc_alumno_nombres} ${solicitud.soc_alumno_apellidos}</h6>
          <div style="background-color: #f5f5f5; padding: 15px; border-radius: 4px; margin-bottom: 20px;">
            <p><strong>RUT:</strong> ${solicitud.soc_alumno_rut}-${solicitud.soc_alumno_dv}</p>
            <p><strong>Nombre Pasajero:</strong> ${solicitud.soc_alumno_nombres} ${solicitud.soc_alumno_apellidos}</p>
            <p><strong>Responsable:</strong> ${solicitud.soc_responsable_nombres} ${solicitud.soc_responsable_apellidos}</p>
            <p><strong>Parentesco:</strong> ${solicitud.soc_responsable_parentesco || '-'}</p>
          </div>
          
          <h6 style="color: #2196F3; margin-bottom: 15px; font-weight: bold;">Datos de Cuota</h6>
          
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Fecha Primera Cuota</label>
          <input type="date" id="fecha_primera_cuota" class="form-control" style="margin-bottom: 15px;" required />
          
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Fecha Última Cuota</label>
          <input type="date" id="fecha_ultima_cuota" class="form-control" style="margin-bottom: 15px;" required />
          
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Valor de la Cuota ($)</label>
          <input type="number" id="valor_cuota" class="form-control" placeholder="0" style="margin-bottom: 15px;" required />
          
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Fecha de Pago de Reserva</label>
          <input type="date" id="fecha_pago_reserva" class="form-control" style="margin-bottom: 15px;" required />
          
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Monto de la Reserva ($)</label>
          <input type="number" id="monto_reserva" class="form-control" placeholder="0" style="margin-bottom: 15px;" required />

          ${valorExtraGira && valorExtraGira > 0 ? `
            <div style="background-color: #fff3cd; border: 1px solid #ffc107; border-radius: 4px; padding: 12px; margin-top: 15px;">
              <p style="margin: 0; color: #856404;">
                <i class="material-icons" style="font-size: 1.1rem; vertical-align: middle; margin-right: 8px;">attach_money</i>
                <strong>Valor Extra a Pagar (Cupo Adicional):</strong> <span style="font-size: 1.1rem; color: #d39e00;">$${valorExtraGira.toLocaleString('es-CL')}</span>
              </p>
              <small style="color: #856404; display: block; margin-top: 5px;">Se sumará al monto total de la gira</small>
            </div>
          ` : ''}
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const fechaPrimeraCuota = document.getElementById('fecha_primera_cuota').value;
        const fechaUltimaCuota = document.getElementById('fecha_ultima_cuota').value;
        const valorCuota = document.getElementById('valor_cuota').value;
        const fechaPagoReserva = document.getElementById('fecha_pago_reserva').value;
        const montoReserva = document.getElementById('monto_reserva').value;

        if (!fechaPrimeraCuota || !fechaUltimaCuota || !valorCuota || !fechaPagoReserva || !montoReserva) {
          Swal.showValidationMessage('Por favor completa todos los campos');
          return false;
        }

        return {
          fechaPrimeraCuota,
          fechaUltimaCuota,
          valorCuota,
          fechaPagoReserva,
          montoReserva
        };
      },
      confirmButtonText: 'Aprobar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      icon: 'info'
    });

    if (formValues) {
      Swal.fire({
        title: 'Aprobando solicitud...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const resultado = await aprobarSolicitudCupo(solicitud.soc_id, formValues);
      
      Swal.close();

      if (!resultado.error) {
        Swal.fire({
          icon: 'success',
          title: 'Solicitud Aprobada',
          text: `La solicitud ha sido aprobada. El alumno se agregará a la gira con los siguientes datos:\n\nValor Cuota: $${Number(formValues.valorCuota).toLocaleString('es-CL')}\nReserva: $${Number(formValues.montoReserva).toLocaleString('es-CL')}`
        }).then(() => {
          cargarSolicitudes();
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: resultado.msg || 'Error al aprobar solicitud'
        });
      }
    }
  };

  const handleRechazar = async (solicitud) => {
    const { value: motivo } = await Swal.fire({
      title: 'Rechazar Solicitud de Cupo',
      html: `
        <div style="text-align: left;">
          <p style="margin-bottom: 15px;">
            <strong>Alumno:</strong> ${solicitud.soc_alumno_nombres} ${solicitud.soc_alumno_apellidos}<br/>
            <strong>RUT:</strong> ${solicitud.soc_alumno_rut}-${solicitud.soc_alumno_dv}
          </p>
          <label style="display: block; margin-bottom: 8px; font-weight: bold;">Motivo del Rechazo</label>
          <textarea id="motivo_rechazo" class="form-control" rows="4" placeholder="Indicar el motivo del rechazo..." required></textarea>
        </div>
      `,
      focusConfirm: false,
      preConfirm: () => {
        const motivoTexto = document.getElementById('motivo_rechazo').value;
        if (!motivoTexto.trim()) {
          Swal.showValidationMessage('Por favor indica un motivo');
          return false;
        }
        return motivoTexto;
      },
      confirmButtonText: 'Rechazar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      icon: 'warning'
    });

    if (motivo) {
      Swal.fire({
        title: 'Rechazando solicitud...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      const resultado = await rechazarSolicitudCupo(solicitud.soc_id, motivo);
      
      Swal.close();

      if (!resultado.error) {
        Swal.fire({
          icon: 'success',
          title: 'Solicitud Rechazada',
          text: 'La solicitud ha sido rechazada. El responsable recibirá la notificación.'
        }).then(() => {
          cargarSolicitudes();
        });
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: resultado.msg || 'Error al rechazar solicitud'
        });
      }
    }
  };

  const solicitudesFiltradas = solicitudes.filter(s => s.soc_estado === filtro);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ 
          display: 'inline-block',
          width: '40px',
          height: '40px',
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #2196F3',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          marginBottom: '15px'
        }}></div>
        <p style={{ color: '#666', marginTop: '10px' }}>Cargando solicitudes...</p>
        <p style={{ color: '#999', fontSize: '0.85rem' }}>ID Gira: {giraId}</p>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '30px',
        backgroundColor: '#FFEBEE',
        borderRadius: '4px',
        border: '1px solid #EF5350',
        color: '#C62828'
      }}>
        <i className='material-icons' style={{ fontSize: '3rem', color: '#EF5350' }}>error</i>
        <p style={{ margin: '10px 0 0 0', fontWeight: 'bold' }}>
          Error al cargar solicitudes
        </p>
        <p style={{ margin: '5px 0', fontSize: '0.9rem' }}>
          {error}
        </p>
        <p style={{ margin: '10px 0 0 0', fontSize: '0.85rem', color: '#999' }}>
          ID Gira: {giraId}
        </p>
      </div>
    );
  }

  if (solicitudes.length === 0) {
    return (
      <div style={{ 
        textAlign: 'center', 
        padding: '30px',
        backgroundColor: '#f5f5f5',
        borderRadius: '4px'
      }}>
        <i className='material-icons' style={{ fontSize: '3rem', color: '#ccc' }}>note</i>
        <p style={{ color: '#999', marginTop: '10px' }}>
          No hay solicitudes de cupo para esta gira (ID: {giraId})
        </p>
        <p style={{ color: '#bbb', fontSize: '0.9rem' }}>
          Cuando un responsable solicite un nuevo cupo, aparecerá aquí
        </p>
      </div>
    );
  }

  return (
    <div style={{ marginTop: '20px' }}>
      <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
        <button 
          className={`btn ${filtro === 'pendiente' ? 'btn-warning' : 'btn-outline-warning'}`}
          onClick={() => setFiltro('pendiente')}
        >
          Pendientes ({solicitudes.filter(s => s.soc_estado === 'pendiente').length})
        </button>
        <button 
          className={`btn ${filtro === 'aprobado' ? 'btn-success' : 'btn-outline-success'}`}
          onClick={() => setFiltro('aprobado')}
        >
          Aprobadas ({solicitudes.filter(s => s.soc_estado === 'aprobado').length})
        </button>
        <button 
          className={`btn ${filtro === 'rechazado' ? 'btn-danger' : 'btn-outline-danger'}`}
          onClick={() => setFiltro('rechazado')}
        >
          Rechazadas ({solicitudes.filter(s => s.soc_estado === 'rechazado').length})
        </button>
      </div>

      <div style={{ overflowX: 'auto' }}>
        <Table striped bordered hover size="sm">
          <thead style={{ backgroundColor: '#2196F3', color: 'white' }}>
            <tr>
              <th style={{ textAlign: 'center' }}>Alumno</th>
              <th style={{ textAlign: 'center' }}>RUT</th>
              <th style={{ textAlign: 'center' }}>Responsable</th>
              <th style={{ textAlign: 'center' }}>Estado</th>
              <th style={{ textAlign: 'center' }}>Fecha Solicitud</th>
              <th style={{ textAlign: 'center' }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {solicitudesFiltradas.map((solicitud, index) => (
              <tr key={index}>
                <td>
                  <strong>{solicitud.soc_alumno_nombres} {solicitud.soc_alumno_apellidos}</strong>
                </td>
                <td>{solicitud.soc_alumno_rut}-{solicitud.soc_alumno_dv}</td>
                <td>{solicitud.soc_responsable_nombres} {solicitud.soc_responsable_apellidos}</td>
                <td style={{ textAlign: 'center' }}>
                  {getEstadoBadge(solicitud.soc_estado)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {formatearFecha(solicitud.soc_fecha_creacion)}
                </td>
                <td style={{ textAlign: 'center' }}>
                  {solicitud.soc_estado === 'pendiente' && (
                    <div style={{ display: 'flex', gap: '5px', justifyContent: 'center', flexWrap: 'wrap' }}>
                      <ButtonComponent
                        className="btn btn-sm btn-success"
                        onClick={() => handleAprobar(solicitud)}
                      >
                        <i className='material-icons' style={{ fontSize: '0.9rem' }}>check_circle</i> Aprobar
                      </ButtonComponent>
                      <ButtonComponent
                        className="btn btn-sm btn-danger"
                        onClick={() => handleRechazar(solicitud)}
                      >
                        <i className='material-icons' style={{ fontSize: '0.9rem' }}>cancel</i> Rechazar
                      </ButtonComponent>
                    </div>
                  )}
                  {solicitud.soc_estado !== 'pendiente' && (
                    <ButtonComponent
                      className="btn btn-sm btn-info"
                      onClick={() => mostrarDetalles(solicitud)}
                    >
                      <i className='material-icons' style={{ fontSize: '0.9rem' }}>search</i> Ver
                    </ButtonComponent>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </div>
  );

  function mostrarDetalles(solicitud) {
    let contenidoHTML = `
      <div style="text-align: left;">
        <h5 style="color: #2196F3; margin-bottom: 15px; font-weight: bold;">Datos del Alumno</h5>
        <p><strong>Nombre:</strong> ${solicitud.soc_alumno_nombres} ${solicitud.soc_alumno_apellidos}</p>
        <p><strong>RUT:</strong> ${solicitud.soc_alumno_rut}-${solicitud.soc_alumno_dv}</p>
        <p><strong>Calidad:</strong> ${solicitud.soc_alumno_calidad}</p>
        
        <hr style="margin: 20px 0;" />
        
        <h5 style="color: #2196F3; margin-bottom: 15px; font-weight: bold;">Datos del Responsable</h5>
        <p><strong>Nombre:</strong> ${solicitud.soc_responsable_nombres} ${solicitud.soc_responsable_apellidos}</p>
        <p><strong>RUT:</strong> ${solicitud.soc_responsable_rut}-${solicitud.soc_responsable_dv}</p>
        <p><strong>Parentesco:</strong> ${solicitud.soc_responsable_parentesco || '-'}</p>
        
        <hr style="margin: 20px 0;" />
        
        <h5 style="color: #2196F3; margin-bottom: 15px; font-weight: bold;">Estado de la Solicitud</h5>
        <p><strong>Estado:</strong> ${solicitud.soc_estado.charAt(0).toUpperCase() + solicitud.soc_estado.slice(1)}</p>
        <p><strong>Fecha de Solicitud:</strong> ${formatearFecha(solicitud.soc_fecha_creacion)}</p>
        ${solicitud.soc_fecha_aprobacion ? `<p><strong>Fecha de Revisión:</strong> ${formatearFecha(solicitud.soc_fecha_aprobacion)}</p>` : ''}
        ${solicitud.soc_razon_rechazo ? `<p style="color: #d32f2f; background-color: #ffebee; padding: 10px; border-radius: 4px;"><strong>Motivo del Rechazo:</strong> ${solicitud.soc_razon_rechazo}</p>` : ''}
      </div>
    `;

    Swal.fire({
      title: 'Detalle de Solicitud',
      html: contenidoHTML,
      icon: 'info',
      confirmButtonText: 'Cerrar',
      width: '600px'
    });
  }
}
